import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { selectDeviceFields } from 'entities/device/lib/selectors';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { send_terminal_command } from 'shared/components/panels/terminal/redux/actions';
import { useCallback } from 'react';
import { secondsToDelay } from 'utils';
function generateCommandsToSendToServer(device, to_test_server) {
    if (device == null) {
        return [];
    }
    const has_z3k_settings = LegacyDevice.has_capability(device.capabilities, Capability.has_z3k_settings);
    let server = 'office.microline.ru';
    let port = 52200;
    if (!to_test_server) {
        server = 's1.zont-online.ru,s2.zont-online.ru';
        port = 52200;
    }
    if (has_z3k_settings) {
        return [`#S200=${server}`, `#S201=${port}`, '#S15=1', 'RESTART'];
    }
    return [`IPA=${server}`, `IPP=${port}`];
}
export const useSendToServer = function useSendToServer(device_id) {
    const onSendCommand = useAction(send_terminal_command);
    const device = useAppSelector(selectDeviceFields(device_id, ['id', 'capabilities']));
    const onSendToServer = useCallback(async (send_to_test_server) => {
        const commands = generateCommandsToSendToServer(device, send_to_test_server);
        for (const command of commands) {
            onSendCommand(device_id, command);
            await secondsToDelay(1);
        }
    }, [device_id]);
    return onSendToServer;
};
